import { useMemo } from 'react';
import { WidgetConfig } from '@/types';
import { defaultConfig } from '@/config/widget.config';

export const useWidgetConfig = (): WidgetConfig => {
  const config = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Parse with_phone parameter (accepts 'true', '1', 'True', 'TRUE')
    const withPhoneParam = urlParams.get('with_phone');
    const withPhone = withPhoneParam !== null && 
      ['true', '1', 'True', 'TRUE'].includes(withPhoneParam);
    
    return {
      logoText: urlParams.get('logoText') || defaultConfig.logoText,
      logoUrl: urlParams.get('logoUrl') || defaultConfig.logoUrl,
      clientName: urlParams.get('clientName') || defaultConfig.clientName,
      primaryColor: urlParams.get('primaryColor') || defaultConfig.primaryColor,
      secondaryColor: urlParams.get('secondaryColor') || defaultConfig.secondaryColor,
      withPhone,
      // apiEndpoint removed - now uses BFF at /api/generate-lead
    };
  }, []);

  return config;
};
